import '@/components/sticky-header'
import { trackShortlist } from '@/components/shortlist'
import { manageMobileMenu } from '@/components/mobileMenu'
import { lazyImages } from '@/components/lazyImages'

manageMobileMenu()
trackShortlist()
lazyImages()
